import { render, staticRenderFns } from "./HwAnalysisTabClassBar.vue?vue&type=template&id=08332bf8&scoped=true"
import script from "./HwAnalysisTabClassBar.vue?vue&type=script&lang=js"
export * from "./HwAnalysisTabClassBar.vue?vue&type=script&lang=js"
import style0 from "./HwAnalysisTabClassBar.vue?vue&type=style&index=0&id=08332bf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08332bf8",
  null
  
)

export default component.exports